import { React, useCallback } from 'react';
// import { returnReceipt, setReceiptPrintCopy } from '../../actions/checks';
import classes from './NavZReportsVchasno.module.css';
import {
  Button,
  Modal,
  Table,
  Accordion,
  InputGroup,
  FormControl,
  Container,
  Row,
  Col,
  Form,
  Stack
} from 'react-bootstrap';
import ReportsIcon from '../../../../images/reports.svg';
import Loader from '../../../../images/loader.gif';
import SearchIcon from '../../../../images/search-icon.svg';
// import SearchIcon from '../../../../images/search-icon.svg';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useZReportsVchasno } from './hooks/useZReportsVchasno';
import { formatDate, formatMoney, formatWeight } from '../../../../helpers/dataFormatter';
// import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import DatePickerSelect from '../../../ui/DatePickerSelect';

const NavZReportsVchasno = (props) => {
  const {
    zReportsList,
    getZReports,
    printZReport,
    modalShow,
    showLoader,
    filterDateStart,
    filterDateEnd,
    setModalShow,
    frId
  } = useZReportsVchasno();

  const frSelectHandler = (e) => {
    getZReports(e.target.value, filterDateStart, filterDateEnd);
  }

  function parseVchasnoDate(dateString) {
    // Validate input
    if (!dateString || !/^\d{17}$/.test(dateString)) {
      throw new Error('Invalid date format. Expected YYYYMMDDHHMMSSmmm (17 digits).');
    }

    // Extract components
    const year = parseInt(dateString.slice(0, 4), 10); // YYYY
    const month = parseInt(dateString.slice(4, 6), 10) - 1; // MM (0-based for JS Date)
    const day = parseInt(dateString.slice(6, 8), 10); // DD
    const hours = parseInt(dateString.slice(8, 10), 10); // HH
    const minutes = parseInt(dateString.slice(10, 12), 10); // MM
    const seconds = parseInt(dateString.slice(12, 14), 10); // SS
    const milliseconds = parseInt(dateString.slice(14, 17), 10); // mmm

    // Create and validate Date object
    const date = new Date(year, month, day, hours, minutes, seconds, milliseconds);

    if (isNaN(date.getTime())) {
      throw new Error('Invalid date components.');
    }

    return date;
  }

  return (
    <div>
      <Button
        className={`me-md-2 ${classes.button}`}
        size='sm'
        onClick={(e) => {
          e.target.parentElement.focus();
          e.target.parentElement.blur();
          setModalShow(true)
        }}
      >
        <img className={classes.nav_icon} src={ReportsIcon} alt='checklist' /> <div className={classes.icon_text}>Z звіти</div>
      </Button>
      {modalShow && (
        <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          size='xl'
          centered
          scrollable={true}
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          {showLoader === true && (
            <img
              className='position-absolute top-50 start-50 translate-middle'
              src={Loader}
              style={{ width: '100px' }}
              alt=''
            />
          )}
          <Modal.Header closeButton>
            <Modal.Title id='contained-modal-title-vcenter'>
              Z звіти
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className={classes.modal_body}>
            <Container>
              <Row key="filter-row">
                <Col key="date-start" style={{ paddingTop: '3px' }} xs={6} md={2}>
                  <DatePickerSelect
                    dateValue={filterDateStart}
                    onChange={(date) => {
                      getZReports(frId, date, filterDateEnd);
                    }}
                  />
                </Col>
                <Col key="date-end" style={{ paddingTop: '3px' }} xs={6} md={2}>
                  <DatePickerSelect
                    dateValue={filterDateEnd}
                    onChange={(date) => {
                      getZReports(frId, filterDateStart, date);
                    }}
                  />
                </Col>
                <Col key="search" style={{ paddingTop: '3px' }} xs={6} md={2}>
                  <Form.Select size="lg" style={{ width: '300px', height: '38px', top: '1px', fontSize: '1.1rem' }} value={frId} onChange={frSelectHandler}>
                    <option key={0} value={0}>{'Всі'}</option>
                    {props.fiscalRegistrars && props.fiscalRegistrars.map((item) => {
                      return (
                        <option key={item.id} value={item.id}>{item.name}</option>
                      )
                    })}
                  </Form.Select>
                </Col>
              </Row>
            </Container>
            <Accordion className='mt-1' flush>
              {zReportsList &&
                zReportsList.length > 0 &&
                zReportsList.map((item) => {
                  return (
                    <Accordion.Item eventKey={'history-' + item.id} key={'history-' + item.id}>
                      <Accordion.Header className={classes.header} as='div'>
                        {`ФН: ${item.fisn} від ${formatDate(parseVchasnoDate(item.end_dt))}, ${formatMoney(item?.sum ?? 0)}₴`}
                      </Accordion.Header>
                      <Accordion.Body className='p-0'>
                        <Button
                          className='ms-2 mb-2'
                          size='sm'
                          variant='outline-secondary'
                          onClick={(event) => {
                            console.log('printZReport-click');
                            printZReport(item.id, item.fisn, item.localn);
                          }}
                        >
                          Друк
                        </Button>
                      </Accordion.Body>
                    </Accordion.Item>
                  );
                })}
            </Accordion>
          </Modal.Body>
        </Modal>
      )
      }
    </div >
  );
};

export default NavZReportsVchasno;
